import { api } from "../App";
import { SET_DATASETS_LIST, SET_DATASETS_ALL_LIST, SET_FIELD_ALL_LIST, SET_FIELDS } from "./types";



export const getDatasetsList = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get('/nnz_datasets')
    dispatch({ type: SET_DATASETS_LIST, payload: data });
  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};
// таблицы для выпадашки в модалке создания описания
export const getDatasetsAllList = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get('/nnz_datasets/all')
    dispatch({ type: SET_DATASETS_ALL_LIST, payload: data });
  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};


export const createTableDescription = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/nnz_datasets`, data)
    dispatch(getDatasetsList())
  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};

///// ПОЛЯ (ВТОРОЯ ТАБЛИЦА) ВЫБРОННОЙ ТАБЛИЦЫ 
export const getFieldAllList = (dataset_id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/nnz_field/${dataset_id}/all`)
    dispatch({ type: SET_FIELD_ALL_LIST, payload: data });
  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};

export const getFields = (dataset_id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/nnz_fields/${dataset_id}`)
    dispatch({ type: SET_FIELDS, payload: data });
  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};

export const createTableField = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/nnz_field`, data)
    dispatch(getFields(data.dataset_id))
  } catch (ERR) {
    console.log(ERR)
  } finally {
  }
};